import { Tag } from 'antd';
import styled from 'styled-components';

export const TimelineContainer = styled.div`
  margin: 20px 0;
`;

export const DateTag = styled(Tag)`
  margin-bottom: 8px !important;
`;